import React, { useState, useEffect } from 'react';
import dataProvider from '../../lib/dataProvider';
import { getInfoValue, isHauptadmin } from '../../lib/globalData';
import { useTranslate } from 'react-admin';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import get from 'lodash/get';


const TrEmbed = (text) => {
  const tr = useTranslate();
  if (!text || typeof text !== 'string') return text;
  const pattern = /%([^%]+)%/g;
  
  return text.replace(pattern, (match, key) => {
    const translated = tr(key, { _: key });
    if(translated && translated !== key){
      return translated
    }
    return match;
  });
};

const EmbedArray = (value) => {
  return (
    <Grid container>
      {value.map(val => (<Grid item xs={12} md={12}>{TrEmbed(val)}</Grid>))}
    </Grid>
  )
}

const StatRow = ({source, stats}) => {
  const tr = useTranslate();
  var value = get(stats, source, '');
  if(!value)return
  return (
    <Grid container sx={{mb: '.5em'}}>
      <Grid item xs={12} md={4}>
        {tr('bw.rep.stats.'+source)}
      </Grid>
      <Grid item xs={12} md={8}>
        {typeof value !== 'object'?TrEmbed(value):EmbedArray(value)}
      </Grid>
    </Grid>
  )
}

const UserArray = (value) => {
  return (
    <Grid container>
      {value.map(val => (<>
        <Grid item xs={3} md={3}>{val?.type}</Grid>
        <Grid item xs={4} md={4}>{val?.login}</Grid>
        <Grid item xs={5} md={5}>{val?.last}</Grid></>))
      }
    </Grid>
  )
}

const UserRow = ({source, stats, filter, setFilter}) => {
  const tr = useTranslate();
  var value = get(stats, source, '');
  if(!value)return
  return (
    <Grid container>
      <Grid item xs={12} md={3} sx={{fontWeight: 'bold'}}>
        {tr('bw.rep.stats.'+source)}
      </Grid>
      <Grid item xs={12} md={9} sx={{mt: '.2em'}}>
        <Checkbox checked={filter!==''} onChange={ev=>{setFilter(ev.target.checked?'_showall':'')}} sx={{p:0,mr: '.5em', mt: '-.2em'}} />
        <span style={{marginTop: '.3em'}}>{tr('bw.rep.stats.showall')}</span>
      </Grid>
      <Grid item xs={12} md={12} sx={{mt: '.5em'}}>
        {UserArray(value)}
      </Grid>
    </Grid>
  )
}

const ArrayCell = (value) => (
  value.map(val => (<div>{val}</div>))
)

const CalcArray = (value, valtot) => {
  return (
    <table>
      {value.map(val => (<tr>
        <td>{typeof val[0] !== 'object'?val[0]:ArrayCell(val[0])}</td>
        <td>{typeof val[1] !== 'object'?val[1]:ArrayCell(val[1])}</td>
        <td>{typeof val[2] !== 'object'?val[2]:ArrayCell(val[2])}</td>
        <td>{typeof val[3] !== 'object'?val[3]:ArrayCell(val[3])}</td>
        <td align='right'>{typeof val[4] !== 'object'?val[4]:ArrayCell(val[4])}</td></tr>))
      }
      <tr>
        <th align='left'>Total</th>
        <th></th>
        <th></th>
        <th></th>
        <th align='right'>{valtot}</th>
      </tr>
    </table>
  )
}

const CalcRow = ({source, stats}) => {
  const tr = useTranslate();
  var value = get(stats, source, '');
  var valtot = get(stats, 'total', '');
  if(!value)return
  return (
    <Grid container>
      <Grid item xs={12} md={12} sx={{fontWeight: 'bold'}}>
        {tr('bw.rep.stats.'+source)}
      </Grid>
      <Grid item xs={12} md={12} sx={{mt: '.5em'}}>
        {CalcArray(value, valtot)}
      </Grid>
    </Grid>
  )
}

const Stats = () => {
  const tr = useTranslate();
  const [stats, setStats] = useState({});
  const [filter, setFilter] = useState('');
  
  useEffect(() => {
    setStats({})
    dataProvider.getOne('repStats', { id: getInfoValue('id_hostel')+filter })
      .then(res  => {
        console.log(res)
        if(res.data)setStats(res.data)
      })
  }, [filter]);
  
  if(!stats?.id)return
  console.log(stats)
  return (         
    <Paper style={{scroll:'auto'}} >
      <div style={{ fontWeight: 'bold', fontSize: '2em', marginTop: '3em', marginLeft: '.25em' }}>{tr('bw.rep.stats.title')}</div>
      <Grid container sx={{mb: '.5em', ml: '1em'}}>
        <Grid item xs={12} md={6}>
          <StatRow stats={stats} source="DBcon" />
          <StatRow stats={stats} source="res_nr" />
          <StatRow stats={stats} source="resdatum" />
          <StatRow stats={stats} source="onlinedatum" />
          <StatRow stats={stats} source="cnt" />
          <StatRow stats={stats} source="gastinfo" />
          <StatRow stats={stats} source="dayinfo_min" />
          <StatRow stats={stats} source="dayinfo_max" />
          <StatRow stats={stats} source="roominfo" />
          <StatRow stats={stats} source="bedinfo" />
        </Grid>
        <Grid item xs={12} md={6}>
          <UserRow stats={stats} source="users" setFilter={setFilter} filter={filter} />
        </Grid>
        { isHauptadmin() && <Grid item xs={12} md={6}>
          <CalcRow stats={stats} source="abr" />
        </Grid>}
      </Grid>
    </Paper>
  )
}
export default Stats;
